module.exports = __webpack_public_path__ + "static/media/sw2.bd3bc4a6.jpg";